/**
 * @generated SignedSource<<03da0b9f9a78c7960adffce85c275847>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MultipleAssistancesContentTemplate_salesAssociate$data = {
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "MultipleAssistancesContentTemplate_salesAssociate";
};
export type MultipleAssistancesContentTemplate_salesAssociate$key = {
  readonly " $data"?: MultipleAssistancesContentTemplate_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultipleAssistancesContentTemplate_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultipleAssistancesContentTemplate_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "42b293971ec64a0e0e43d3238d3bc971";

export default node;
